import { useEffect } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { useClickstreamCallback } from '@zenbusiness/application-commons-clickstream';
import { useExperimentTrackCallback } from '@zenbusiness/application-commons-experiments';
import PageLoading from '@zenbusiness/zui/PageLoading';

import useFlowConfig from '#client/hooks/flow/useFlowConfig';
import useFlowState from '#client/hooks/flow/useFlowState';
import * as pageUtils from '#client/utils/flowPage';

const FlowEntry = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { autoResume, id: flowId, pages } = useFlowConfig();
  const { lastPage } = useFlowState();
  const trackFlowInitialized = useClickstreamCallback('flowInitialized');
  const trackExperimentEvent = useExperimentTrackCallback();

  const isLastPageValid = pageUtils.isPageValid(pages, lastPage);
  const lastPagePath = pageUtils.getPagePath({ flowId, page: lastPage });
  const firstPagePath = pageUtils.getPagePath({ flowId, page: pageUtils.getFirstPage(pages) });

  useEffect(() => {
    // If an entry_uri query param is present... this was a POST from a landing page
    // We need to track key marketing and experiment events if this is the case
    if (searchParams.has('entry_uri')) {
      // Flow Initialized is a key marketing event
      trackFlowInitialized();
      // Funnel Start is a key experiment event
      trackExperimentEvent('Funnel Start');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Only run this effect once to avoid side effects

  // Handle redirecting into the flow
  useEffect(() => {
    if (lastPagePath && isLastPageValid && autoResume && lastPagePath !== firstPagePath) {
      // Resume flow progress
      navigate(`${lastPagePath}?resumed`, { replace: true });
    } else {
      // Start at the beginning of the flow
      navigate(`${firstPagePath}?started`, { replace: true });
    }
  }, [autoResume, firstPagePath, isLastPageValid, lastPagePath, navigate]);

  return <PageLoading />;
};

export default FlowEntry;
